import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({}) => css`
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
  `}
`;

export default Wrapper(template);
